import type { TFunction } from "i18next";

import { SupportRole } from "~/graphql/graphql.gen";

export const getRoles = (t: TFunction) => [
  {
    value: SupportRole.SuperAdmin,
    label: t("role.super_admin"),
  },
  {
    value: SupportRole.Admin,
    label: t("role.admin"),
  },
  {
    value: SupportRole.Agent,
    label: t("role.agent"),
  },
  {
    value: SupportRole.Market,
    label: t("role.market"),
  },
  {
    value: SupportRole.OperatorManager,
    label: t("role.operator_manager"),
  },
  {
    value: SupportRole.Emerch,
    label: t("role.emerch"),
  },
  {
    value: SupportRole.Viewer,
    label: t("role.viewer"),
  },
];

export const VIEWER_ROLES = [
  SupportRole.SuperAdmin,
  SupportRole.Admin,
  SupportRole.Agent,
  SupportRole.OperatorManager,
  SupportRole.Market,
  SupportRole.Emerch,
  SupportRole.Viewer,
];

export const AGENT_ROLES = [
  SupportRole.SuperAdmin,
  SupportRole.Admin,
  SupportRole.Agent,
  SupportRole.OperatorManager,
];

export const AGENT_OR_MARKETING_ROLES = [
  SupportRole.SuperAdmin,
  SupportRole.Admin,
  SupportRole.Agent,
  SupportRole.OperatorManager,
  SupportRole.Market,
];

export const AGENT_OR_EMERCH_OR_MARKETING_ROLES = [
  SupportRole.SuperAdmin,
  SupportRole.Admin,
  SupportRole.Agent,
  SupportRole.OperatorManager,
  SupportRole.Market,
  SupportRole.Emerch,
];

export const ADMIN_ROLES = [SupportRole.SuperAdmin, SupportRole.Admin];

export const sortRole = (a: SupportRole, b: SupportRole) => {
  const map = new Map<string, number>();
  map.set(SupportRole.SuperAdmin, 0);
  map.set(SupportRole.Admin, 1);
  map.set(SupportRole.Agent, 2);
  map.set(SupportRole.OperatorManager, 3);
  map.set(SupportRole.Emerch, 4);
  map.set(SupportRole.Viewer, 5);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if (map.get(a)! < map.get(b)!) {
    return -1;
  }
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if (map.get(a)! > map.get(b)!) {
    return 1;
  }
  return 0;
};
